import React, { Component } from "react";
import { Avatar } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Input from '@mui/material/Input';
import { IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; import Stack from "@mui/material/Stack";
import "../../styles/components.css";
import { TextField } from "@mui/material";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { BudgetCategories } from "../../utils/mockData";
import wyzrTheme from "../../styles/customTheme";
import InputAdornment from '@mui/material/InputAdornment';
import PoundIcon from "../../images/pound.png";
import { updateHeightAfterContentUpdate } from "../../utils/helperFns";
export class EditBudgetUpcomingTransaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transaction: this.props.transaction,
      selectedDate: Date.now(),
      transactionAmount : this.props.unit === "1" ? this.props.transaction.amount_co2 : this.props.transaction.amount,
      budgetCategories: BudgetCategories,
      category : this.props.category,
      subcategory: this.props.subCategory,
      frequency:"Monthly"
    };
  }
  
  inputHandler = (value) => {
    this.setState({transactionAmount:value})
}

closeScreen = () => {
    if(this.state.transactionAmount > 0){
      var t = this.state.transaction;
      t.amount = this.state.transactionAmount;
      t.amount = parseFloat(t.amount).toFixed(2);
      this.setState({transaction:t});
    }
      this.props.toggleHandler();
}

  handleCategoryChange = (selectedValue) => {
    var t = this.state;
    t.category = selectedValue.target.value;
    this.setState(t);
  }

  handleSubcategoryChange = (selectedValue) => {
    var t = this.state;
    t.subcategory = selectedValue.target.value;
    this.setState(t);
  }

  handleFrequencyChange = (selectedValue) => {
    var t = this.state;
    t.frequency = selectedValue.target.value;
    this.setState(t);
  };

  render() {
    return (
      <Box className="popup" id="child_EditBudgetUpcomingTransaction">
        <Box className="popupClose popupClose-alt">
          <IconButton aria-label="Close" onClick={this.closeScreen}>
            <ArrowBackIcon />
          </IconButton>
        </Box>

        <Stack direction="column" alignItems="center" gap={2} marginTop={2}>
          <Typography variant="body1" color="text.secondary" fontWeight="700">Tap to edit</Typography>
          <Avatar sx={{ backgroundColor: "grey.100", width: 40, height: 40 }}>
            <Box sx={{ fontWeight: "bold" }} color="primary.main">
              {this.state.transaction.logo}
            </Box>
          </Avatar>

          <Box marginBottom={2}>
            <Input className="inputBold-md" defaultValue={this.state.transaction.desc} aria-label="transaction text" />
          </Box>
        </Stack>
        <Grid
          container
          mt={5}
          mb={2}
          marginX="auto"
          maxWidth={380}
          padding={2}
        >
          <Stack justifyContent="space-between" direction="row" width="100%" marginBottom={3}>
            <Typography variant="body1" fontWeight="700" color="text.secondary">
              Category
            </Typography>
            <Select
              value={this.state.category}
              className="inputBold-sm"
              onChange={this.handleCategoryChange}
              label="Age"
              defaultValue={this.state.category}
              variant="standard"
              fullWidth
            >
              {this.state.budgetCategories.map((el, i) => (
                <MenuItem key={`category-${i}`} value={el}>{el}</MenuItem>
              ))
              }
            </Select>
          </Stack>

          <Stack justifyContent="space-between" direction="row" width="100%" marginBottom={3}>
            <Typography variant="body1" fontWeight="700" color="text.secondary">
              Sub Category
            </Typography>
            <Select
              value={this.state.subcategory}
              className="inputBold-sm"
              onChange={this.handleSubcategoryChange}
              label="Age"
              defaultValue={this.state.subcategory}
              variant="standard"
              fullWidth
            >
              {this.state.budgetCategories.map((el, i) => (
                <MenuItem key={`subcategory-${i}`} value={el}>{el}</MenuItem>
              ))
              }
            </Select>
          </Stack>

          <Stack justifyContent="space-between" direction="row" width="100%" marginBottom={3}>
            <Typography variant="body1" fontWeight="700" color="text.secondary">
              Predicted Amount
            </Typography>
            <Box display={"flex"} flexDirection={"column"} sx={{ textAlign: "left" }}>
            <TextField className="inputBold-sm" type="number" 
              InputProps={{
                min: 0,
                startAdornment: (
                  <InputAdornment position="start">
                  <img height={14} width={14} src={PoundIcon} alt="icon" />
              </InputAdornment>
                ),
              }}
              onChange={(event) => this.inputHandler(event.target.value)}
              variant="standard" defaultValue={this.state.transactionAmount}
            />
            {this.state.transactionAmount < 0 ? <Typography variant='caption' color={wyzrTheme.palette.error.light}>This value can't be negative.</Typography>:null}
            </Box>
          
          </Stack>

          <Stack justifyContent="space-between" direction="row" width="100%" marginBottom={3}>
            <Typography variant="body1" fontWeight="700" color="text.secondary">
              Predicted payment date
            </Typography>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="dd/MM/yyyy"
                value={this.state.selectedDate}
                onChange={(newValue) => {
                  this.setState({ selectedDate: newValue })
                }}
                minDate={new Date()}
                renderInput={(params) => <TextField className="inputBold-sm" sx={{ textAlign: "right" }} variant="standard" {...params} />}
              />
            </LocalizationProvider>

          </Stack>

          <Stack justifyContent="space-between" direction="row" width="100%" marginBottom={3}>
            <Typography variant="body1" fontWeight="700" color="text.secondary">
              Frequency
            </Typography>
            <Select
              className="inputBold-sm"
              onChange={this.handleFrequencyChange}
              value={this.state.frequency}
              variant="standard"
              fullWidth
            >
              <MenuItem value="Weekly">Weekly</MenuItem>
              <MenuItem value="Monthly">Monthly</MenuItem>
              <MenuItem value="Yearly">Yearly</MenuItem>
            </Select>
          </Stack>


          <Stack justifyContent="space-between" direction="row" width="100%" marginBottom={3}>
            <Typography variant="body1" fontWeight="700" color="text.secondary">
              Remove this transaction
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="subtitle2" fontWeight="800">No</Typography>
              <Switch />
              <Typography variant="subtitle2" fontWeight="800">Yes</Typography>
            </Stack>
          </Stack>
        </Grid>
        {updateHeightAfterContentUpdate("child_BudgetCategory", "child_EditBudgetUpcomingTransaction", "parent_BudgetBreakdown")}
      </Box>
    );
  }
}

export default EditBudgetUpcomingTransaction;
